import React, { FC, useState, useCallback, useEffect } from "react"
import { message, Modal, Select } from "antd"
import { announcement, time } from "services"
import { InputBox } from "components"
import { RoomList } from "services/time"
import { PrivateCard } from "services/announcement"

interface DialogType {
  list?: PrivateCard[],
  isOpen: boolean,
  onSubmit: () => void
  onClose: () => void
}

const Dialog: FC<DialogType> = (props) => {
  const { Option } = Select
  const [option, setOption] = useState<number>()

  const handleClickSubmit = useCallback(() => {
    if (!option) {
    } else {
      (async () => {
        try {
          await announcement.addPrivateCard({ id: option })
          props.onSubmit()
        } catch (err) {
          err.response && message.error(err.response.data.message)
        }
      })()
    }
  }, [option])

  return (
    <Modal
      title='新增配置'
      visible={props.isOpen}
      onCancel={props.onClose}
      onOk={handleClickSubmit}
    >
      <InputBox style={{ display: 'flex', justifyContent: 'center' }} title='选择预约项目'>
        <Select onChange={(value) => { setOption(value as number) }} style={{ width: 200 }} placeholder='请选择预约对象'>
          {props.list && props.list.length ? props.list.map(item =>
            <Option key={item.id} value={item.id}>{item.title}</Option>
          ) : null
          }
        </Select>
      </InputBox>
    </Modal>
  )
}

export default Dialog